import React from 'react';
import './SplashScreen.css';
import {logo} from '../../themes/defaultTheme';
import { useEffect } from 'react';
import sponsorUoN from '../../assets/base/sponsor.uon.png';
import sponsorEwi from '../../assets/base/sponsor.ewi.png';

function SplashScreen({loading=true}) {

  useEffect(() => {
    if(!loading){
      setTimeout(() => {
        document.querySelector('.splash-image').classList.add('pulse');
      }, 1000);
    }
  },[loading])

  return (
    <div className={`splash-screen`}>
      <img src={logo} alt="Splash Screen" className="splash-image" />
      <div className="splash-sponsors">
        <span className="splash-sponsors-label">Supported by</span>
        <div className="splash-sponsors-logos">
          <img src={sponsorUoN} alt="University of Nottingham" className="splash-sponsor-uon" />
          <img src={sponsorEwi} alt="EWI" className="splash-sponsor-ewi" />
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;